<form [formGroup]="form">
  @if (items.length) {
    <gbc-table [clickableRows]="clickable">
      <th gbc-table-header style="width: 100px">
        {{ 'facility-selector.selected' | translate }}
      </th>
      @for (headerEntry of header; track headerEntry) {
        <th gbc-table-header>
          {{ headerEntry.title }}
        </th>
      }
      @for (item of items; track item) {
        <tr gbc-table-row>
          <td gbc-table-cell>
            <gbc-checkbox [formControlName]="item.id.toString()" [name]="item.id.toString()"></gbc-checkbox>
          </td>
          @for (headerEntry of header; track headerEntry) {
            <td gbc-table-cell (click)="rowClick.emit(item.id.toString())">
              {{ item[headerEntry.key] }}
            </td>
          }
        </tr>
      }
    </gbc-table>
  } @else {
    <gbc-table>
      <tr gbc-table-row>
        <td gbc-table-cell colspan="2">
          {{ fallbackMessage }}
        </td>
      </tr>
    </gbc-table>
  }

</form>
